export default __webpack_public_path__ + "static/media/Step2.e478912f.png";